/*
  Surf Syndicate — native cart drawer extras.

  Everything here sits on top of Dawn's own drawer (cart-drawer.js / cart.js)
  and re-uses its rendering: every change asks Shopify for the fresh
  `cart-drawer` section in the same request and hands it to the drawer, so the
  drawer never shows a stale cart and never needs a second round trip.

  1. Kit offer and suggestions: fetched after the drawer opens. Suggestions
     are cached per product and filtered against what's already in the cart
     and the saved truck.
  2. One-tap add for suggestions, and the kit swap (parts out, kit in).
  3. Discount codes through the Ajax cart.
  4. The fitment line at the top of the drawer.
*/
(function () {
  if (window.__ssCartExtras) return;
  window.__ssCartExtras = true;

  var MAX_RECS = 3;
  var recCache = {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionIds() {
    var d = drawer();
    return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : [];
  }

  function post(url, body) {
    var config = fetchConfig('javascript');
    config.body = JSON.stringify(body);
    return fetch(url, config).then(function (r) { return r.json(); });
  }

  function busy(btn, on) {
    if (!btn) return;
    btn.classList.toggle('loading', on);
    btn.toggleAttribute('disabled', on);
  }

  // Add items and hand the fresh drawer straight to Dawn, which opens it.
  function addAndRender(items) {
    var d = drawer();
    return post(routes.cart_add_url, {
      items: items,
      sections: sectionIds(),
      sections_url: window.location.pathname
    }).then(function (state) {
      if (state.status) throw new Error(state.description || state.message || 'Could not add to cart');
      d.renderContents(state);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ss-cart', cartData: state });
      return state;
    });
  }

  // Re-render just the inside of the drawer, as Dawn's quantity changes do.
  function renderInner(state) {
    var html = state.sections && state.sections['cart-drawer'];
    if (!html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer__inner');
    var current = document.querySelector('#CartDrawer .drawer__inner');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var bubble = state.sections['cart-icon-bubble'];
    var bubbleEl = document.getElementById('cart-icon-bubble');
    if (bubble && bubbleEl) {
      var b = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section');
      if (b) bubbleEl.innerHTML = b.innerHTML;
    }
  }

  function showError(msg) {
    var el = document.getElementById('CartDrawer-CartErrors');
    if (el) el.textContent = msg || window.cartStrings.error;
  }

  /* ---------- Suggestions ---------- */

  function fetchRecs(productId, intent) {
    var url = root + 'recommendations/products?product_id=' + encodeURIComponent(productId) +
      '&limit=8&section_id=ss-cart-recs&intent=' + intent;
    return fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
  }

  function cardsFrom(html) {
    if (!html) return [];
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.prototype.slice.call(doc.querySelectorAll('.ss-rec'));
  }

  function recsFor(productId) {
    if (!recCache[productId]) {
      recCache[productId] = fetchRecs(productId, 'complementary').then(function (html) {
        return cardsFrom(html).length ? html : fetchRecs(productId, 'related');
      });
    }
    return recCache[productId];
  }

  function fitsSavedTruck(card) {
    if (!window.SSFitment) return true;
    var v = SSFitment.get();
    if (!v) return true;
    return SSFitment.check(SSFitment.fromEl(card), v) !== 'no-fit';
  }

  function fillRecs() {
    var box = document.querySelector('cart-drawer [data-ss-cart-recs]:not([data-ready])');
    if (!box) return;
    box.setAttribute('data-ready', '');
    var productId = box.getAttribute('data-product-id');
    if (!productId) return;
    var exclude = (box.getAttribute('data-exclude') || '').split(',');

    recsFor(productId).then(function (html) {
      if (!box.isConnected) return;
      var list = box.querySelector('.ss-recs__list');
      var shown = 0;
      cardsFrom(html).forEach(function (card) {
        if (shown >= MAX_RECS) return;
        if (exclude.indexOf(card.getAttribute('data-product-id')) !== -1) return;
        if (!fitsSavedTruck(card)) return;
        list.appendChild(document.importNode(card, true));
        shown++;
      });
      box.hidden = shown === 0;
    });
  }

  /* ---------- Kit offer ---------- */

  // Kits are the store's own bundle products, read live from the Storefront
  // API: `groupedBy` lists every published bundle that contains a given
  // variant, with its parts and prices. Nothing to keep in sync: publish,
  // edit or archive a bundle in Shopify and the cart follows. Tokenless
  // access covers this; an old API version keeps working because Shopify
  // serves retired versions from the oldest supported one.
  var SF_URL = root + 'api/2026-10/graphql.json';
  var KIT_QUERY =
    'query($ids: [ID!]!, $country: CountryCode) @inContext(country: $country) {' +
    ' nodes(ids: $ids) { ... on ProductVariant { id groupedBy(first: 25) { nodes {' +
    ' id title availableForSale price { amount } product { id handle title }' +
    ' components(first: 10) { nodes { quantity productVariant {' +
    ' id title price { amount } product { id title featuredImage { url } } } } } } } } } }';
  var fitCache = {};

  function numId(gid) {
    return Number(String(gid).split('/').pop());
  }

  // Same cut as the product page heading and ss-short-title.liquid.
  function shortTitle(title) {
    var cuts = [' for Toyota', ' | ', ' l '];
    for (var i = 0; i < cuts.length; i++) {
      if (title.indexOf(cuts[i]) !== -1) return title.split(cuts[i])[0];
    }
    return title;
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function moneyFormatter(currency) {
    var f = new Intl.NumberFormat('en-NZ', { style: 'currency', currency: currency });
    return function (amount) { return f.format(amount); };
  }

  // Every way each bundle could be offered, best first: most of its parts
  // already in the cart, then fewest still missing. Bundles already in the
  // cart, unavailable, or not actually cheaper are left out.
  function rankKits(cart, nodes) {
    var linesByVariant = {};
    var productsInCart = {};
    cart.items.forEach(function (item) {
      (linesByVariant[item.variant_id] = linesByVariant[item.variant_id] || []).push(item);
      productsInCart[item.product_id] = true;
    });

    var byProduct = {};
    nodes.forEach(function (node) {
      if (!node || !node.groupedBy) return;
      node.groupedBy.nodes.forEach(function (kit) {
        if (!kit.availableForSale || productsInCart[numId(kit.product.id)]) return;
        var entry = byProduct[kit.product.id] = byProduct[kit.product.id] || { product: kit.product, variants: {} };
        entry.variants[kit.id] = kit;
      });
    });

    var ranked = [];
    Object.keys(byProduct).forEach(function (pid) {
      var entry = byProduct[pid];
      var best = null, ties = 0;
      Object.keys(entry.variants).forEach(function (vid) {
        var kit = entry.variants[vid];
        var parts = kit.components.nodes;
        var have = 0, partsTotal = 0;
        parts.forEach(function (c) {
          partsTotal += Number(c.productVariant.price.amount) * c.quantity;
          if (linesByVariant[numId(c.productVariant.id)]) have++;
        });
        var saving = partsTotal - Number(kit.price.amount);
        if (saving <= 0.005) return;
        var score = have * 100 - parts.length;
        if (!best || score > best.score) { best = { kit: kit, score: score, partsTotal: partsTotal, saving: saving }; ties = 1; }
        else if (score === best.score) ties++;
      });
      // More than one variant fits equally well, e.g. only the armrests are
      // in the cart and the kit also has dash mat colours: let them choose.
      if (best) { best.product = entry.product; best.choose = ties > 1; ranked.push(best); }
    });
    ranked.sort(function (a, b) { return b.score - a.score || b.saving - a.saving; });

    ranked.forEach(function (r) {
      var remove = [];
      r.kit.components.nodes.forEach(function (c) {
        var lines = linesByVariant[numId(c.productVariant.id)];
        if (lines) remove.push(lines[0].key + ':' + Math.max(0, lines[0].quantity - c.quantity));
      });
      r.remove = remove.join(',');
      r.inCart = function (c) { return !!linesByVariant[numId(c.productVariant.id)]; };
    });
    return ranked;
  }

  // Only asked when a truck is saved: skip a kit made for other years.
  function kitFits(handle) {
    var v = window.SSFitment && SSFitment.get();
    if (!v) return Promise.resolve(true);
    if (!fitCache[handle]) {
      fitCache[handle] = fetch(root + 'products/' + handle + '?view=ss-fit')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return fitCache[handle].then(function (part) {
      return !part || SSFitment.check(part, v) !== 'no-fit';
    });
  }

  function firstThatFits(ranked) {
    var i = 0;
    function next() {
      if (i >= ranked.length || i >= 4) return Promise.resolve(null);
      var r = ranked[i++];
      return kitFits(r.product.handle).then(function (ok) { return ok ? r : next(); });
    }
    return next();
  }

  function kitHtml(r, money) {
    var parts = r.kit.components.nodes.map(function (c) {
      var pv = c.productVariant;
      var img = pv.product.featuredImage ? pv.product.featuredImage.url : '';
      if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=120';
      var name = shortTitle(pv.product.title);
      // Colours only once the kit variant is settled; while they still have
      // to choose, naming one would be a guess.
      if (!r.choose && pv.title !== 'Default Title') name += ' · ' + pv.title;
      var have = r.inCart(c);
      return '<li class="ss-kit__part' + (have ? ' is-in-cart' : '') + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : '<span></span>') +
        '<span class="ss-kit__part-name">' + esc(name) + (c.quantity > 1 ? ' × ' + c.quantity : '') + '</span>' +
        '<span class="ss-kit__part-state">' + (have ? 'In cart' : esc(money(Number(pv.price.amount) * c.quantity))) + '</span></li>';
    }).join('');

    var cta = r.choose
      ? '<a class="button ss-kit__cta" href="' + esc(root + 'products/' + r.product.handle + '?variant=' + numId(r.kit.id)) + '">Choose kit options, save ' + esc(money(r.saving)) + '</a>'
      : '<button type="button" class="button ss-kit__cta" data-ss-kit-swap data-kit-variant="' + numId(r.kit.id) + '" data-remove="' + esc(r.remove) + '">Upgrade to the kit, save ' + esc(money(r.saving)) + '</button>';

    return '<div class="ss-kit">' +
      '<p class="ss-kit__eyebrow">Complete the kit</p>' +
      '<p class="ss-kit__title">' + esc(shortTitle(r.product.title)) + '</p>' +
      '<ul class="ss-kit__parts list-unstyled">' + parts + '</ul>' +
      '<p class="ss-kit__price">Kit price <strong>' + esc(money(Number(r.kit.price.amount))) + '</strong> <s>' + esc(money(r.partsTotal)) + '</s></p>' +
      cta + '</div>';
  }

  function fillKit() {
    var slot = document.querySelector('cart-drawer [data-ss-cart-kit]:not([data-ready])');
    if (!slot) return;
    slot.setAttribute('data-ready', '');

    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items.length) return null;
        var ids = [];
        cart.items.forEach(function (item) {
          var gid = 'gid://shopify/ProductVariant/' + item.variant_id;
          if (ids.indexOf(gid) === -1 && ids.length < 20) ids.push(gid);
        });
        return fetch(SF_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            query: KIT_QUERY,
            variables: { ids: ids, country: (window.Shopify && Shopify.country) || 'NZ' }
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (!res.data) return null;
            return firstThatFits(rankKits(cart, res.data.nodes)).then(function (pick) {
              return pick && kitHtml(pick, moneyFormatter(cart.currency));
            });
          });
      })
      .then(function (html) {
        if (html && slot.isConnected) slot.innerHTML = html;
      })
      .catch(function () {});
  }

  /* ---------- Fitment line ---------- */

  function fillFit() {
    // Filling the bar is itself a change inside the drawer, so mark it done
    // or the observer below would keep refilling it.
    var bar = document.querySelector('cart-drawer [data-ss-cartfit]:not([data-ready])');
    if (!bar || !window.SSFitment) return;
    bar.setAttribute('data-ready', '');
    var v = SSFitment.get();

    if (!v) {
      bar.className = 'ss-cartfit';
      bar.innerHTML = '<span>Add your truck to check fitment</span>' +
        '<button type="button" class="ss-cartfit__btn" data-ss-garage-open>Add vehicle</button>';
      bar.hidden = false;
      return;
    }

    var rows = document.querySelectorAll('cart-drawer tr.cart-item[data-ss-fit]');
    var noFit = 0;
    for (var i = 0; i < rows.length; i++) {
      if (SSFitment.check(SSFitment.fromEl(rows[i]), v) === 'no-fit') noFit++;
    }

    var name = document.createElement('strong');
    name.textContent = SSFitment.describe(v);
    bar.className = 'ss-cartfit ' + (noFit ? 'ss-cartfit--warn' : 'ss-cartfit--ok');
    bar.innerHTML = '';
    var text = document.createElement('span');
    text.appendChild(document.createTextNode(noFit
      ? noFit + (noFit === 1 ? ' part' : ' parts') + ' may not fit your '
      : 'Checked for your '));
    text.appendChild(name);
    bar.appendChild(text);
    var change = document.createElement('button');
    change.type = 'button';
    change.className = 'ss-cartfit__btn';
    change.setAttribute('data-ss-garage-open', '');
    change.textContent = 'Change';
    bar.appendChild(change);
    bar.hidden = false;
  }

  /* ---------- Clicks and forms ---------- */

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var add = t.closest('[data-ss-rec-add]');
    if (add) {
      var card = add.closest('.ss-rec');
      var id = card && card.querySelector('[data-ss-rec-variant]').value;
      if (!id) return;
      busy(add, true);
      addAndRender([{ id: Number(id), quantity: 1 }])
        .catch(function (err) { showError(err.message); })
        .then(function () { busy(add, false); });
      return;
    }

    // Kit swap: take the kit's parts out (data-remove holds each line's new
    // quantity), then add the kit. Two requests, because the Ajax cart can't
    // remove lines and add a new one atomically.
    var swap = t.closest('[data-ss-kit-swap]');
    if (swap) {
      var updates = {};
      (swap.getAttribute('data-remove') || '').split(',').forEach(function (pair) {
        if (!pair) return;
        var cut = pair.lastIndexOf(':');
        updates[pair.slice(0, cut)] = parseInt(pair.slice(cut + 1), 10);
      });
      busy(swap, true);
      post(routes.cart_update_url, { updates: updates })
        .then(function () {
          return addAndRender([{ id: Number(swap.getAttribute('data-kit-variant')), quantity: 1 }]);
        })
        .catch(function (err) { showError(err.message); })
        .then(function () { busy(swap, false); });
      return;
    }

    if (t.closest('[data-ss-discount-remove]')) {
      applyDiscount('', null);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-ss-discount]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input');
    var code = (input.value || '').trim();
    if (code) applyDiscount(code, form.querySelector('button'));
  });

  function applyDiscount(code, btn) {
    busy(btn, true);
    post(routes.cart_update_url, {
      discount: code,
      sections: sectionIds(),
      sections_url: window.location.pathname
    })
      .then(function (state) {
        renderInner(state);
        if (!code) return;
        var hit = (state.discount_codes || []).filter(function (d) {
          return d.code.toUpperCase() === code.toUpperCase();
        })[0];
        var msg = document.querySelector('cart-drawer [data-ss-discount-msg]');
        if (msg && (!hit || !hit.applicable)) {
          msg.textContent = '“' + code + '” isn’t valid for this cart.';
          msg.closest('details').open = true;
        }
      })
      .catch(function () { showError(); })
      .then(function () { busy(btn, false); });
  }

  /* ---------- Keep the extras in step with the drawer ---------- */

  // Dawn replaces the drawer's contents on every add and quantity change.
  // Watch only the drawer, and only for new content, then fill it in.
  // A short timer rather than requestAnimationFrame, which some browsers
  // stall for tabs they treat as in the background.
  var pending = 0;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fillFit();
      fillKit();
      fillRecs();
    }, 30);
  }

  function boot() {
    var d = drawer();
    if (!d) return;
    new MutationObserver(refresh).observe(d, { childList: true, subtree: true });
    document.addEventListener('ss:vehicle-changed', function () {
      var bar = document.querySelector('cart-drawer [data-ss-cartfit]');
      if (bar) bar.removeAttribute('data-ready');
      // A different truck can rule a kit in or out, so work it out again.
      var slot = document.querySelector('cart-drawer [data-ss-cart-kit]');
      if (slot) {
        slot.removeAttribute('data-ready');
        slot.innerHTML = '';
      }
      var box = document.querySelector('cart-drawer [data-ss-cart-recs]');
      if (box) {
        box.removeAttribute('data-ready');
        box.querySelector('.ss-recs__list').innerHTML = '';
      }
      refresh();
    });
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
